.budgetCard {
  width: 100%;
}

.budgets {
  display: grid;
  grid-gap: 1.6rem;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
}

.budgetHeader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.subHeading {
  margin-bottom: 2.4rem;
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 1.2;
}

.applyCard {
  display: flex;
  flex-direction: column;
  padding: 2.4rem;
  background-color: rgba(var(--color-action-primary-rgb), 0.3);
  cursor: pointer;
}

.applyCardTitle {
  margin-bottom: 0.8rem;
}

.icon {
  margin-bottom: 0.8rem;
  color: var(--color-semantic-text-neutral20);
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.budgetTotal {
  font-size: 4rem;
  line-height: 1.2;
}

.balance span {
  font-size: 3.2rem;
}

.budgetIcon {
  color: var(--color-icon--budgets);
}
